import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import getCanPlayDash from "selectors/device/getCanPlayDash";
import getCanPlayLegacyDash from "selectors/device/getCanPlayLegacyDash";
import getCanPlayFallbackDash from "selectors/device/getCanPlayFallbackDash";
import getIsDesktop from "selectors/device/getIsDesktop";
import getIsIE from "selectors/device/getIsIE";
import getIsiPad from "selectors/device/getIsiPad";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import { createSelector } from "reselect";

const getPlayerOptions = (state) => state.playerOptions;

const getUsePersistentVideo = createSelector(
  getBrowserVersionFloat,
  getCanPlayDash,
  getCanPlayFallbackDash,
  getCanPlayLegacyDash,
  getIsDesktop,
  getIsIE,
  getIsiPad,
  getIsMobileSafari,
  getPlayerOptions,
  (
    browserVersionFloat,
    canPlayDash,
    canPlayFallbackDash,
    canPlayLegacyDash,
    isDesktop,
    isIE,
    isiPad,
    isMobileSafari,
    playerOptions,
  ) => {
    if (playerOptions.forcePersistentVideo) return true;

    if (!isDesktop) return true;
    if (isMobileSafari || isiPad) return true;

    return (
      isIE &&
      !!browserVersionFloat &&
      Math.floor(browserVersionFloat) === 11 &&
      (canPlayDash || canPlayLegacyDash || canPlayFallbackDash)
    );
  },
);

export default getUsePersistentVideo;
